export const PARENT_PARAMETERS_CONSTANTS = {
    ACCOUNT_TYPE: 'Account Type',
    ACCOUNT_ADDRESS_TYPE: 'Account Address Type',
    ACCOUNT_LOCATION_TYPE: 'Account Location Type',
    ORDER_TYPE:"Order Type"
}